<template>
  <!-- 签到功能 -->
  <div class="signRule">
    <!-- 面包屑导航 -->
    <page-header @back="goBack" :title="$route.meta.title">
      <template slot="controls">
        <el-link
          @click="explain = true"
          style="margin-right: 10px"
          icon="el-icon-question"
          :underline="false"
          type="warning"
          >操作说明</el-link
        >
      </template>
    </page-header>
    <el-scrollbar style="height: calc(100% - 60px); margin-top: 20px">
      <el-form
        :model="formData"
        ref="checkForm"
        :rules="formRule"
        label-position="right"
        label-width="120px"
      >
        <el-form-item label="方案名称" prop="name">
          <el-input v-model="formData.name" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="客户类型" prop="userType">
          <el-checkbox v-model="userTypeAll" @change="getUserTypeAll"
            >全选</el-checkbox
          >
          <el-checkbox-group
            v-model="formData.userType"
            @change="setUserTypeAll"
            style="width: 1000px"
          >
            <el-checkbox
              v-for="item in userTypeList"
              :key="item.value"
              :label="item.value"
            >
              {{ item.label }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="签到模式" prop="mode">
          <el-select
            v-model="formData.mode"
            placeholder="请选择签到模式"
            style="width: 200px"
          >
            <el-option label="累计签到" value="1"></el-option>
            <el-option label="连续签到" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="签到规则编辑"
          prop="rule"
          class="el-form-required-true"
        >
          <el-table
            :data="ruleList"
            stripe
            border
            tooltip-effect="dark"
            style="
              width: 1000px;
              border: 1px solid #ebeef5;
              border-bottom: none;
            "
          >
            <el-table-column label="序号" align="center" width="50">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              label="奖励方式"
            >
              <template>
                <span>积分</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              label="签到天数"
            >
              <template slot-scope="scope">
                <el-input-number
                  v-if="scope.$index == 0"
                  v-model="formData.rule.num"
                  :min="0"
                  style="width: 90%"
                ></el-input-number>
                <span v-else>{{ scope.row.num }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip label="积分">
              <template slot-scope="scope">
                <el-input-number
                  v-if="scope.$index == 0"
                  v-model="formData.rule.price"
                  :min="0"
                  style="width: 90%"
                ></el-input-number>
                <span v-else>{{ scope.row.price }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="160">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  style="padding: 2px 3px"
                  plain
                  @click="setRuleData('')"
                  v-if="scope.$index == 0"
                  >确定</el-button
                >
                <el-button
                  type="danger"
                  style="padding: 2px 3px"
                  plain
                  @click="setRuleData(scope.row)"
                  v-else
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="内容编辑" prop="text">
          <!-- <wang-editor :value="formData.text" @change="change" style="width: 800px"></wang-editor> -->
          <tinymce
            :value="formData.text"
            @input="change"
            :isEditorLoad="isEditorLoad"
            style="width: 800px"
          ></tinymce>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm">保存</el-button>
          <el-button type="info" @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </el-scrollbar>

    <el-dialog
      title="操作说明"
      :visible.sync="explain"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="70%"
    >
      <div class="explain-text">
        <p>
          用户获得积分的途径有两种，一种是下单赠送，一种是签到赠送。下单赠送1元送1积分，签到送积分可自定义
        </p>
        <div>
          <p>
            累计签到模式：按照自然月来计算，可以设置每天签到可获取的积分数量，中途不能断签，断签后按照设定好的规则从第一天算起。如果连续签到达到设定天数的上限且没有跨月，则剩余每天签到获取的积分按照规则设置的最后一次积分来计算，持续至本月最后一天。连续七天签到：如果连续签到满7天，从第八天起持续至本月底最后一天，每天签到将获取规则设置中的第七天的积分（不能断签）；如果中途断签，则从规则设置的第一天开始算；跨月后从规则第一天开始算。
          </p>
          <p>
            连续签到模式：累计签到中途可断签，系统会自动统计本月内（自然月）累计签到次数，达到签到规则设定的累计签到次数即可获取相应积分，跨月重新按照规则开始计算
          </p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//组件
// import WangEditor from "@/components/WangEditor.vue";
import Tinymce from "@/components/Tinymce";
//混入
import { mustFill } from "@/mixins/data/valid";

export default {
  name: "signFun",
  data() {
    return {
      id: "",
      formData: {
        name: "",
        userType: [],
        mode: "2",
        rule: {
          id: "",
          num: 0,
          price: 0,
        },
        text: "",
      },
      userTypeAll: false,
      formRule: {
        name: [mustFill],
        userType: [mustFill],
        mode: [mustFill],
        text: [mustFill],
      },
      userTypeList: [],
      ruleList: [
        {
          id: "",
          num: 0,
          price: 0,
        },
      ],
      isEditorLoad: false, // 编辑器是否加载完成

      /**使用说明 */
      explain: false,
    };
  },
  components: {
    Tinymce,
  },
  mounted() {
    let prams = JSON.parse(decodeURIComponent(this.$route.query.prams));
    if (prams) {
      this.id = prams.id;
      this.getData();
      this.getRuleList();
    } else {
      // 新增的时候清空一下临时表数据，就不需要再获取了
      this.deleteRuleList();
      // this.getRuleData()
    }
    this.getUserType();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
      this.$destroy();
    },

    /**富文本编辑内容改变回调 */
    change(val) {
      this.formData.text = val;
    },

    // 获取规则数据
    getData() {
      let data = {
        type: "QuerySingin",
        fabh: this.id,
      };
      let proc = "Proc_SignLog"; // 存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "SignLog/ashx/returnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          console.log(res);
          if (res.flag == 0) {
            this.formData.name = res.data[0].faName;
            this.formData.userType = res.data[0].clientType.split(",");
            this.setUserTypeAll();
            this.formData.mode = res.data[0].faType;
            this.formData.text = decodeURIComponent(atob(res.data[0].content));
            this.isEditorLoad = true;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    // 获取规则数据
    getRuleList() {
      let data = {
        // type: "QuerySinginRule",
        type: "EditSinginRule",
        fabh: this.id,
      };
      let proc = "Proc_SignLog"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "SignLog/ashx/returnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          if (res.flag == 0) {
            this.formData.rule = { id: "", num: 0, price: 0 };
            this.ruleList = [{ id: "", num: "", price: "" }].concat(
              res.data.map((item) => ({
                id: item.sortId,
                num: item.signRule,
                price: item.signReward,
              }))
            );
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    // 获取客户类型
    getUserType() {
      let data = {
        type: "CustomType",
      };
      let proc = "Proc_Admin_CustomerList"; // 存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "coupon/ashx/returnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          if (res.flag == 0) {
            this.userTypeList = res.data.map((item) => ({
              label: item.clienttype,
              value: item.TypeID,
            }));
            this.setUserTypeAll();
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    // 设置全选
    setUserTypeAll() {
      this.userTypeAll =
        this.userTypeList.length == this.formData.userType.length;
    },

    getUserTypeAll(value) {
      if (value) {
        this.formData.userType = this.userTypeList.map((item) => item.value);
      } else {
        this.formData.userType = [];
      }
    },

    // 获取规则数据
    getRuleData() {
      let data = {
        type: "QueryLog",
      };
      let proc = "Proc_SignLog"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "SignLog/ashx/returnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          if (res.flag == 0) {
            this.formData.rule = { id: "", num: 0, price: 0 };
            this.ruleList = [{ id: "", num: "", price: "" }].concat(
              res.data.map((item) => ({
                id: item.id,
                num: item.signrule,
                price: item.signreward,
              }))
            );
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    // 设置规则数据
    setRuleData(row) {
      let data = {
        type: "InsertSign",
        RewardForm: "积分",
        SignRule: this.formData.rule.num,
        SignReward: this.formData.rule.price,
      };
      if (row) {
        data = {
          type: "DelSign",
          Id: row.id,
        };
      }
      let proc = "Proc_SignLog"; //存储过程名
      let type = "ReturnNumber";
      this.$requestSys({
        url:
          "SignLog/ashx/returnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "Post",
      })
        .then((res) => {
          if (res.flag == 0) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.getRuleData();
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**提交表单 */
    submitForm() {
      this.$refs["checkForm"].validate((valid) => {
        if (valid) {
          let clientName = this.formData.userType
            .map((item) => {
              let label = "";
              this.userTypeList.forEach((item1) => {
                if (item1.value == item) {
                  label = item1.label;
                }
              });
              return label;
            })
            .join(",");
          let data = {
            type: "CreateSign",
            planName: this.formData.name,
            clientType: this.formData.userType.join(","),
            clientName: clientName,
            signModel: this.formData.mode,
            content: btoa(encodeURIComponent(this.formData.text)),
            fabh: this.id,
          };
          let proc = "Proc_SignLog"; // 存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            url:
              "SignLog/ashx/returnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            method: "Post",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.goBack();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
              // 获取成功后价格导航菜单的数据存放在vuex中，方便调用
            })
            .catch((err) => {
              window.console.log(err);
            });
        }
      });
    },

    /**重置表单 */
    resetForm() {
      this.$refs["checkForm"].resetFields();
    },

    /**新增的时候清空签到规则临时表数据，要不然新增临时表也会显示数据 */
    deleteRuleList() {
      let data = {
        type: "DltInsertSignRule",
      };
      let proc = "Proc_SignLog"; //存储过程名
      let type = "ReturnNumber";
      this.$requestSys({
        method: "post",
        url:
          "SignLog/ashx/returnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      });
    },
  },
};
</script>

<style scoped>
.signRule {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
